module.exports = __webpack_public_path__ + "static/media/action_girl_eng.ca73f848.mp3";